module.exports = __webpack_public_path__ + "img/page6_blur.628cb557.png";